import {NgModule, Injector} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DirectivesModule} from '../../directives-module/directives.module';
import {createCustomElement} from '@angular/elements';
import {Routes, RouterModule} from '@angular/router';
import {ParksCubesComponent} from "./component/parks-cubes.component";

const routes: Routes = [];

@NgModule({
  declarations: [ParksCubesComponent],
  imports: [CommonModule, DirectivesModule, RouterModule.forChild(routes)],
  entryComponents: [ParksCubesComponent]
})
export class ParkCubesModule {
  constructor(injector: Injector) {
    if (customElements.get('app-park-cubes') == null) {
      const el = createCustomElement(ParksCubesComponent, { injector });
      customElements.define('app-park-cubes', el);
    }
  }
}
